import { Injectable } from '@angular/core';
import { AlertController, Platform } from '@ionic/angular';
import { AppVersion } from '@ionic-native/app-version/ngx';
import { HTTP } from '@ionic-native/http/ngx';
import { File } from '@ionic-native/file/ngx';
import { FileOpener } from '@ionic-native/file-opener/ngx';
import { GlobalService } from '../services/global.service';


interface LatestInfo {
  versionName: string;
  versionCode: string;
  apkUrl: string;  
}

@Injectable({ providedIn: 'root' })
export class AppUpdateService {
    private latestUrl;
    private folderName = 'updates';
    private currentCode;
    private currentName;
    private currentPkNa;
    private currentNum;
    private nombreCliente;



  constructor(
    private platform: Platform,
    public global: GlobalService,
    private alertCtrl: AlertController,
    private appVersion: AppVersion,
    private http: HTTP,
    private file: File,
    private fileOpener: FileOpener
  ) {}

  async checkForUpdate() {

    this.global.versionAPI  = this.global.version.split(".").slice(0, 3).join(".");


    if (!this.platform.is('android')) return;
    // VersionCode local (Android)
    this.currentCode = await this.appVersion.getVersionCode().then();
    this.currentName = await this.appVersion.getAppName().then();
    this.currentPkNa = await this.appVersion.getPackageName().then();
    this.currentNum = await this.appVersion.getVersionNumber().then();

    this.global.versionAPI  = this.currentNum.split(".").slice(0, 3).join(".");
    this.global.version     = this.currentNum;

    this.nombreCliente = this.currentPkNa.substring(this.currentPkNa.lastIndexOf('.') + 1); // "casalma"


    this.latestUrl = `https://${this.nombreCliente}.overlink.es/app/latest.json`; // <-- cambia esto

    // Evita CORS con HTTP nativo
    this.http.setDataSerializer('json');
    const res = await this.http.get(this.latestUrl, {}, {});
    const latest = JSON.parse(res.data) as LatestInfo;

    if (!latest || !latest.versionCode || !latest.apkUrl) return;

    if (latest.versionCode > this.currentCode) {
      const alert = await this.alertCtrl.create({
        header: 'Actualización disponible',
        message: `Versión ${latest.versionName} (${latest.versionCode}). ¿Deseas instalarla?`,
        buttons: [
          { text: 'Luego', role: 'cancel' },
          { text: 'Actualizar', handler: () => this.downloadAndInstall(latest) }
        ]
      });
      await alert.present();
    }
  }

  private async downloadAndInstall(latest: LatestInfo) {
    try {
      this.global.actualizo = true;
      
      // Carpeta destino en almacenamiento externo de caché (visible para instalador)
      const baseDir = this.file.externalCacheDirectory || this.file.cacheDirectory!;
      const targetDir = baseDir + this.folderName + '/';

     
      const fileName = `${this.nombreCliente}${latest.versionCode}.apk`;
      const targetPath = targetDir + fileName;

      // Asegura carpeta
      const exists = await this.file.checkDir(baseDir, this.folderName).catch(() => false);
      if (!exists) await this.file.createDir(baseDir, this.folderName, false);

      // Descarga nativa al path absoluto
      await this.http.downloadFile(latest.apkUrl, {}, {}, targetPath);

      // (Opcional) Verificar SHA-256:
      // Para verificar realmente el hash, usa un plugin nativo de hashing o haz la verificación del lado servidor.
      // Evita calcularlo en JS sobre ficheros grandes por rendimiento.

      // Abrir instalador
      await this.fileOpener.open(targetPath, 'application/vnd.android.package-archive');
      // El sistema continúa el proceso de instalación.
    } catch (e) {
      const alert = await this.alertCtrl.create({
        header: 'Error',
        message: 'No se pudo descargar o abrir el instalador. Revisa conexión o permisos.',
        buttons: ['OK']
      });
      await alert.present();
      
      
      this.global.actualizo = false;

      console.error('Update error:', e);
    }
  }
}
